import { z } from "zod";
import { SyntheticEvent, useCallback, useEffect, useMemo, useState } from "react";
import { TfaMethod } from "@/core/constants/tfaMethod";
import useChangePassword from "@/domains/playerMenu/hooks/useChangePassword";
import PlayerMenuSettingsSafetyChangePasswordEmailCheckContainer from "@/domains/playerMenu/containers/settings/safety/change-password/method/check/PlayerMenuSettingsSafetyChangePasswordEmailCheckContainer";
import PlayerMenuSettingsSafetyChangePasswordEmailSend from "@/domains/playerMenu/components/settings/safety/changePassword/method/PlayerMenuSettingsSafetyChangePasswordEmailSend";

const emailSchema = z.string().email({ message: "Некорректный email" });

type Props = {
  setStep: (step: number) => void;
  goToChangePassword: () => void;
};

export default function PlayerMenuSettingsSafetyChangePasswordEmailContainer({
  setStep,
  goToChangePassword,
}: Props) {
  const { sendError, sendCodeHandler, sendIsPending, sendIsCompleted } = useChangePassword();
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState<string>("");

  useEffect(() => {
    if (email) {
      try {
        setEmailError("");
        emailSchema.parse(email);
      } catch (error) {
        if (error instanceof z.ZodError) {
          setEmailError(error.errors[0].message);
        }
      }
    } else {
      setEmailError("");
    }
  }, [email]);

  const error = useMemo(() => emailError || sendError, [emailError, sendError]);

  const onSubmit = useCallback(
    async (e: SyntheticEvent<HTMLFormElement>) => {
      e.preventDefault();
      if (emailError) return;
      sendCodeHandler(email, TfaMethod.EMAIL);
    },
    [email, emailError],
  );

  useEffect(() => {
    if (sendIsCompleted) {
      setStep(2);
    } else {
      setStep(1);
    }
  }, [sendIsCompleted]);

  if (sendIsCompleted) {
    return (
      <PlayerMenuSettingsSafetyChangePasswordEmailCheckContainer
        address={email}
        goToChangePassword={goToChangePassword}
      />
    );
  }

  return (
    <PlayerMenuSettingsSafetyChangePasswordEmailSend
      error={error}
      onSubmit={onSubmit}
      email={email}
      pending={sendIsPending}
      onChange={setEmail}
    />
  );
}
